import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { cloneDeep, set } from 'lodash';

import { socket } from '../../api/sockets';
import { IS_DEMO, IS_SOLIDSUN } from '../../config';
import { demoInitialStore } from '../../../../core/src/shared/demo-init';

import { Variables } from '../types';

export const variablesChange = createAsyncThunk(
  'variables/change',
  async (payload: Partial<Variables>) => {
    socket.emit('store:set', { payload });
  }
);

const initialState = IS_DEMO
  ? { ...demoInitialStore, PREMIUM: !IS_SOLIDSUN }
  : ({} as Variables);

export const variablesSlice = createSlice({
  name: 'variables',
  initialState,
  reducers: {
    variablesSnapshot: (_, { payload }: { payload: Variables }) => payload,
    variablesSet: (state, { payload }: { payload: Partial<Variables> }) =>
      Object.entries(payload).forEach(([path, value]) =>
        set(state, path, value)
      ),
  },
  extraReducers(builder) {
    builder.addCase(variablesChange.pending, (state, { meta: { arg } }) => {
      const newState = cloneDeep(state);

      Object.entries(arg).forEach(([path, value]) =>
        set(newState, path, value)
      );

      return newState;
    });
  },
});

export const { variablesSnapshot, variablesSet } = variablesSlice.actions;
